import * as React from 'react';
import { Progress as ProgressPrimitive } from 'radix-ui';

import { cn } from '@shared/utils/cn';

// LinearProgress Minimal : 4px, extrémités arrondies
const Progress = ({ className, value, ...props }: React.ComponentProps<typeof ProgressPrimitive.Root>) => (
  <ProgressPrimitive.Root
    className={cn('relative h-1 w-full overflow-hidden rounded-full bg-primary/24', className)}
    data-slot="progress"
    value={value}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 rounded-full bg-primary transition-all"
      data-slot="progress-indicator"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
);

// LinearProgress indéterminé (chargement), à placer en haut d'une carte (`absolute inset-x-0 top-0`)
const ProgressIndeterminate = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div
    aria-label="Chargement"
    className={cn('relative h-1 w-full overflow-hidden rounded-full bg-primary/24', className)}
    data-slot="progress-indeterminate"
    role="progressbar"
    {...props}
  >
    <div className="absolute inset-y-0 w-2/5 animate-indeterminate rounded-full bg-primary" />
  </div>
);

export { Progress, ProgressIndeterminate };
